import { callFn } from "./functionsClient";

/**
 * Ожидаем, что backend отдаёт:
 * quoteTrade -> { price, tokensOut, fee, feeBps, slippageBps, expiresAt }
 * placeTrade -> { tradeId, status, price, tokens, fee, newBalance }
 */

export async function quoteTrade({ marketId, side, amountIn, maxSlippageBps }) {
  return await callFn("quoteTrade", {
    marketId,
    side,               // "yes" | "no"
    amountIn,           // число (USDC)
    maxSlippageBps,     // число (bps)
    currency: "USDC",
  });
}

export async function placeTrade({ marketId, side, amountIn, clientOrderId, maxSlippageBps }) {
  return await callFn("placeTrade", {
    marketId,
    side,
    amountIn,
    clientOrderId,
    maxSlippageBps,
    currency: "USDC",
  });
}
